import { Box, Link, Text, TextProps } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';

import { ACCOUNT_LOGIN, DASHBOARD } from '../constants/urls';
import { CookieKeys, useCookie } from '../hooks/useCookie';
import getSearchPhoneNumbers from '../utils/getSearchPhoneNumbers';

type DuplicateDealMessageProps = {
  textAlign?: TextProps['textAlign'];
};

const DuplicateDealMessage = ({ textAlign = 'center' }: DuplicateDealMessageProps) => {
  const [accessToken] = useCookie<string>(CookieKeys.ACCESS_TOKEN);
  const isAuthenticated = !!accessToken;
  const phoneNumber = getSearchPhoneNumbers();

  return (
    <Box textAlign={textAlign}>
      <Text color="red.500" fontWeight="semibold" wordBreak="break-word">
        You've already made progress with this vehicle.
      </Text>
      <Text fontWeight="semibold" mt={1}>
        Sign in to your{' '}
        <Link as={ReactRouterLink} to={isAuthenticated ? DASHBOARD : ACCOUNT_LOGIN}>
          dashboard
        </Link>{' '}
        to pick up where you left off, or give us a call at{' '}
        <Link display="inline-block" href={`tel:+1-${phoneNumber}`}>
          {phoneNumber}
        </Link>
        .
      </Text>
    </Box>
  );
};

export default DuplicateDealMessage;
